import WorkOrderHistoryState from "@aus/Store/Pages/WorkOrderHistory/WorkOrderHistoryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

const initialState: WorkOrderHistoryState = {
    isReordering: {},
    getVmiLocationsParameter: {},
    isExportingOrders: false,
    isVmiOrderHistoryPage: false,
    selectedOrderIds: {},
    getOrdersParameter: {
        customerSequence: "-1",
        additionalQueryStringParameters: {
            isWorkOrder: true,
        },
    },
    filtersOpen: false,
};

const reducer = {
    "Pages/WorkOrderHistory/UpdateSearchFields": (
        draft: Draft<WorkOrderHistoryState>,
        action: { parameter: GetOrdersApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getOrdersParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getOrdersParameter = { ...initialState.getOrdersParameter, ...action.parameter };
        } else {
            draft.getOrdersParameter = { ...draft.getOrdersParameter, ...action.parameter };

            for (const key in draft.getOrdersParameter) {
                const value = (<any>draft.getOrdersParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getOrdersParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getOrdersParameter.page &&
                    draft.getOrdersParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getOrdersParameter.page = 1;
                }
            }
        }
    },
    "Pages/WorkOrderHistory/ClearParameter": (draft: Draft<WorkOrderHistoryState>) => {
        draft.getOrdersParameter = { ...initialState.getOrdersParameter, pageSize: draft.getOrdersParameter.pageSize };
    },
    "Pages/WorkOrderHistory/BeginReorder": (draft: Draft<WorkOrderHistoryState>, action: { orderNumber: string }) => {
        draft.isReordering[action.orderNumber] = true;
    },
    "Pages/WorkOrderHistory/CompleteReorder": (
        draft: Draft<WorkOrderHistoryState>,
        action: { orderNumber: string },
    ) => {
        delete draft.isReordering[action.orderNumber];
    },
    "Pages/WorkOrderHistory/ToggleFiltersOpen": (draft: Draft<WorkOrderHistoryState>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
